/*
 * Copyright (c) 2022 Puratos. All rights reserved.
 */

import * as React from 'react';


export function Panel({children, className, ...props}) {
    return <div className={"panel " + (className || "")} {...props}>
        <div className={"panel-body"}>
            {children}
        </div>
    </div>
}
